import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "56",
  height: "40",
  viewBox: "0 0 56 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "56",
      height: "40",
      rx: "8",
      fill: "#F9F8F7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.632 28V11.2H12.704V25.6H20.144V28H9.632Z",
      fill: "#6A6A6A"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "12",
      r: "6",
      fill: "#6A6A6A"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "28",
      r: "6",
      fill: "#BFBFBF"
    }, null, -1)
  ])))
}
export default { render: render }